<template>
  <div class="main-container">
    <slot name="bread"></slot>
    <div class="main-content clearfix">
      <div class="f-left">
        <template v-if="current">
          <el-scrollbar v-if="hasScroll" style="height: calc(100vh - 148px)">
            <Question
              :isFile="isFile"
              :key="current.index"
              :ques="current"
              :answer="answer"
              :answerImg="answerImg"
              @addImg="addImg"
              @deleteImg="deleteImg"
              showOperate
              shotAnswerEditable
              :reportId="id"
              @change="onChange(current)"
              :readonly="this.$store.state.questionModeSelect == 2 && current.is_confirm == 1"
              :hasAnalysis="this.$store.state.questionModeSelect == 2 && current.is_confirm == 1"
              :showAnalysisBtn="false"
              :showAnswerBtn="true"
            ></Question>
          </el-scrollbar>
          <Question
            v-else
            :isFile="isFile"
            :key="current.index"
            :ques="current"
            :answer="answer"
            showOperate
            :answerImg="answerImg"
            @addImg="addImg"
            @deleteImg="deleteImg"
            shotAnswerEditable
            :reportId="id"
            @change="onChange(current)"
            :readonly="this.$store.state.questionModeSelect == 2 && current.is_confirm == 1"
            :hasAnalysis="this.$store.state.questionModeSelect == 2 && current.is_confirm == 1"
            :showAnalysisBtn="false"
            :showAnswerBtn="true"
          ></Question>
        </template>
      </div>
      <div ref="rightWrap" class="f-right" :style="style">
        <ExamDoRight
          ref="right"
          :reportId="id"
          :scantron="scantron"
          shotAnswerEditable
          :answer="answer"
          :answerImg="answerImg"
          :limitTime="limitTime"
          @topicChange="onTopicChange"
          @submit="submit"
        ></ExamDoRight>
      </div>
    </div>
    <LimitModal v-model="visible" :questionType="$route.query.examType" />
  </div>
</template>
<script>
import Question from '@/components/ques/Question.vue';
import ExamDoRight from './ExamDoRight.vue';
export default {
  name: 'ExamDo',
  components: {
    Question,
    ExamDoRight,
  },
  props: {
    practiceType: {
      default: 0,
    },
    isFile: {
      default: 2,
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      index: 1,
      answer: {},
      visible: false,
      current: {},
      answerImg: {},
      storeKey: 'exam-seconds',
      scantron: {},
      hasScroll: false,
      fixed: 0,
      fixedRight: 0,
      limitTime: 0,
    };
  },
  computed: {
    style() {
      let style = {};
      style.right = this.fixedRight + 'px';
      if (this.fixed == 1) {
        style.position = 'fixed';
        style.top = '70px';
      } else if (this.fixed == 2) {
        style.position = 'absolute';
        style.bottom = '0';
      }
      return style;
    },
  },
  watch: {
    'current.is_sign': {
      handler() {
        this.scantron.list.find((q) => q.question_id == this.current.question_id).is_sign =
          this.current.is_sign;
      },
    },
    current() {
      this.initScroll();
    },
  },
  async created() {
    await this.getTopicStatus();
    this.$nextTick(() => {
      this.$refs.right.init(this.index);
    });
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('scroll', this.setFixed);
      document.addEventListener('resize', this.setFixed);
    });
  },
  destroyed() {
    document.removeEventListener('scroll', this.setFixed);
    document.removeEventListener('resize', this.setFixed);
  },
  methods: {
    setFixed() {
      let $ = window.$;
      let scrollTop = $(document.documentElement).scrollTop();
      if (scrollTop > 48) {
        let footerOffset = $('#footerBar').offset();
        let rightHeight = this.$refs.rightWrap.clientHeight;
        if (footerOffset.top - rightHeight - scrollTop < 100) {
          this.fixed = 2;
          this.fixedRight = 0;
        } else {
          this.fixed = 1;
          this.fixedRight = ($(window).width() - 1200) / 2;
          if (this.fixedRight < 0) {
            this.fixedRight = 0;
          }
        }
      } else {
        this.fixed = 0;
      }
    },
    async getTopicStatus() {
      let data = await this.$http.post('/api/app/practice/scantron', {
        report_id: this.id,
        type: 2,
      });
      let flag = false;
      let answerCount = data.list.filter((t) => t.status == 1 || t.status == 2).length;
      data.list.forEach((t, index) => {
        // 继续上一次题目
        if (answerCount > 0 && !flag && t.status == 3) {
          this.index = Math.min(data.list.length, index + 1);
          flag = true;
        }
      });
      this.scantron = data;
      // 全部模式
      this.$store.commit('setQuestionMode', data.practise_module);
      // 当前模式
      this.$store.commit('setQuestionModeSelect', data.mode);
    },
    addImg(ques, path) {
      let images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    },
    onTopicChange(ques) {
      this.hasScroll = false;
      this.scantron.list.find((q) => q.question_id == ques.question_id).status = ques.status;
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.$set(this.answer, ques.question_id, ques.user_answer);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer ? ques.user_answer.split(',').map((s) => Number(s)) : [],
        );
      } else if (ques.ques_type == 7) {
        const quesRightAns = Array.isArray(ques.right_answer)
          ? ques.right_answer
          : JSON.parse(ques.right_answer);
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer ? ques.user_answer.split('@@') : quesRightAns.map(() => ''),
        );
      } else if (ques.ques_type == 5) {
        //简答题
        if (ques.user_answer) {
          let user_answer = JSON.parse(ques.user_answer);
          this.$set(this.answer, ques.question_id, user_answer.content);
          this.$set(this.answerImg, ques.question_id, user_answer.images);
        }
      }
      this.current = ques;
      if (this.practiceType == 6) {
        this.limitTime = this.current.limit_time;
      }
    }, //status 1对，2错，3，未答，4错
    onChange(ques) {
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        if (this.answer[ques.question_id]) {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 1;

          // examDoRight.vue内部监听状态进行练习模式出答案
          if (this.$store.state.questionModeSelect == 2 && !ques.is_confirm) {
            this.$store.commit('setShowQuestionAnswer', {
              is_confirm: 1,
              get: true,
            });
          } else {
            this.$refs.right.navNext();
          }
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        if (this.answer[ques.question_id].length > 0) {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 1;
        } else {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 3;
        }
      } else if (ques.ques_type == 7) {
        if (this.answer[ques.question_id].some(Boolean)) {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 1;
        } else {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 3;
        }
      } else if (ques.ques_type == 5) {
        //简答题
        if (this.answer[ques.question_id] || (this.answerImg[ques.question_id] || []).length > 0) {
          this.scantron.list.find(
            //简答题为4,为已答
            (q) => q.question_id == ques.question_id,
          ).status = 4;
        } else {
          this.scantron.list.find((q) => q.question_id == ques.question_id).status = 3;
        }
      }
    },
    submit() {
      this.$emit('submit');
    },
    initScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = this.$pub.getScreenHeight();

          if (document.body.clientHeight > height + 148) {
            this.hasScroll = true;
          } else {
            this.hasScroll = false;
          }
        }, 0);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 30px;
  position: relative;
  > .f-left {
    width: 890px;
    border-radius: 5px;

    ::v-deep {
      .el-scrollbar__wrap {
        border-radius: 5px;
      }
      .question {
        background-color: white;
        border-radius: 5px;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__thumb {
        background-color: #bfbfbf;
      }
    }
  }
  > .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 19px 20px;
    box-sizing: border-box;
  }
}
</style>
